export const es: Record<string, string> = {
  "documents.title": "Documentos metodológicos",
  "documents.description": "Consulta directivas, manuales y materiales de la encuesta.",
  "documents.library": "Biblioteca",
  "documents.querying": "Consultando…",
  "documents.filters": "Filtros de documentos",
  "documents.libraryTitle": "Biblioteca documental",
  "documents.libraryDescription": "Encuentra el documento que necesitas por año y tipo.",
  "documents.type": "Tipo de documento",
  "documents.search": "Buscar documento",
  "documents.searchPlaceholder": "Título o nombre del archivo",
  "documents.clearSearch": "Limpiar búsqueda",
  "documents.filterHint": "La búsqueda se aplica al año y tipo seleccionados.",
  "documents.resetFilters": "Restablecer filtros",
  "documents.sort": "Ordenar documentos",
  "documents.sortAsc": "Nombre · A a Z",
  "documents.sortDesc": "Nombre · Z a A",
  "documents.queryingDocuments": "Consultando documentos…",
  "documents.restricted": "Acceso restringido al archivo documental",
  "documents.sourceError": "No se pudo consultar el archivo documental",
  "documents.unavailable": "El archivo documental no está disponible en este momento. Vuelve a intentarlo en unos instantes.",
  "documents.changeFilters": "Puedes cambiar los filtros o volver a consultar.",
  "documents.retryQuery": "Reintentar consulta",
  "documents.noDocuments": "No se encontraron documentos",
  "documents.emptyHint": "Prueba otro año, tipo de documento o término de búsqueda.",
  "documents.available": "Documentos disponibles",
  "documents.pagination": "Paginación de documentos",
  "documents.previousPage": "Página anterior",
  "documents.nextPage": "Página siguiente",
  "documents.ready": "Archivos listos para consultar o descargar",
  "documents.archive": "Archivo documental ENAPRES",
  "documents.queryingStatus": "Consultando documentos.",
  "documents.queryFailed": "No se pudo completar la consulta documental.",
  "documents.downloadError": "No se pudo descargar el documento.",
  "documents.viewPdf": "Ver PDF",
  "documents.downloading": "Descargando…",
  "documents.previewLoading": "Preparando vista previa…",
  "documents.previewSource": "El documento se está cargando desde el archivo documental.",
  "documents.previewError": "No se pudo abrir la vista previa",
  "documents.retryPreview": "Reintentar vista previa",
  "documents.documentReady": "Tu documento está listo",
  "documents.openHint": "Abre el PDF en otra pestaña para leerlo con mayor comodidad o descárgalo para consultarlo después.",
  "documents.openTab": "Abrir PDF en otra pestaña",
  "documents.viewerFallback": "Si no aparece el visor, abre el archivo directamente.",
  "documents.openError": "No se pudo abrir el documento.",
  "documents.libraryError": "No se pudo consultar la biblioteca de documentos.",
  "documents.document": "documento",
  "documents.documents": "documentos",
  "documents.allDocuments": "Documentos",
  "documents.training": "Capacitación",
  "documents.category.1": "Directivas",
  "documents.category.2": "Manuales",
  "documents.category.3": "Cuestionarios",
  "documents.category.80": "Técnicos",
  "documents.category.4": "Anexos",
  "documents.category.97": "Retroalimentación virtual 2023",
  "documents.category.96": "Retroalimentación cartográfica",
  "documents.category.95": "Retroalimentación",
  "documents.category.93": "Retroalimentación presencial",
  "documents.category.94": "Presentaciones",
  "documents.category.98": "Taller",
  "documents.category.100": "Informe final",
  "documents.selectedType": "Tipo seleccionado ({id})",
  "documents.noMatches": "No hay coincidencias para «{search}» en {category} de {year}.",
  "documents.emptyCategory": "No hay documentos disponibles para {category} de {year}.",
  "documents.resultRange": "{start}–{end} de {count} {unit}",
  "documents.page": "Página {page} de {pages}",
  "documents.checkedAt": "Consulta realizada el {date} (Lima).",
  "documents.found": "{count} documentos encontrados.",
  "documents.published": "Publicado el {date}",
  "documents.previewTitle": "Vista previa de {title}",
  "documents.restrictedMessage": "El archivo documental requiere autorización para esta consulta. Inténtalo de nuevo más tarde."
};

export const en: Record<string, string> = {
  "documents.title": "Methodological documents",
  "documents.description": "Browse survey directives, manuals and materials.",
  "documents.library": "Library",
  "documents.querying": "Loading…",
  "documents.filters": "Document filters",
  "documents.libraryTitle": "Document library",
  "documents.libraryDescription": "Find the document you need by year and type.",
  "documents.type": "Document type",
  "documents.search": "Search documents",
  "documents.searchPlaceholder": "Title or file name",
  "documents.clearSearch": "Clear search",
  "documents.filterHint": "Search applies to the selected year and type.",
  "documents.resetFilters": "Reset filters",
  "documents.sort": "Sort documents",
  "documents.sortAsc": "Name · A to Z",
  "documents.sortDesc": "Name · Z to A",
  "documents.queryingDocuments": "Loading documents…",
  "documents.restricted": "Access to the document archive is restricted",
  "documents.sourceError": "The document archive could not be queried",
  "documents.unavailable": "The document archive is currently unavailable. Please try again shortly.",
  "documents.changeFilters": "You can change the filters or try again.",
  "documents.retryQuery": "Retry query",
  "documents.noDocuments": "No documents found",
  "documents.emptyHint": "Try another year, document type or search term.",
  "documents.available": "Available documents",
  "documents.pagination": "Document pagination",
  "documents.previousPage": "Previous page",
  "documents.nextPage": "Next page",
  "documents.ready": "Files ready to view or download",
  "documents.archive": "ENAPRES document archive",
  "documents.queryingStatus": "Loading documents.",
  "documents.queryFailed": "The document query could not be completed.",
  "documents.downloadError": "The document could not be downloaded.",
  "documents.viewPdf": "View PDF",
  "documents.downloading": "Downloading…",
  "documents.previewLoading": "Preparing preview…",
  "documents.previewSource": "The document is loading from the document archive.",
  "documents.previewError": "The preview could not be opened",
  "documents.retryPreview": "Retry preview",
  "documents.documentReady": "Your document is ready",
  "documents.openHint": "Open the PDF in another tab for easier reading or download it to view later.",
  "documents.openTab": "Open PDF in another tab",
  "documents.viewerFallback": "If the viewer does not appear, open the file directly.",
  "documents.openError": "The document could not be opened.",
  "documents.libraryError": "The document library could not be queried.",
  "documents.document": "document",
  "documents.documents": "documents",
  "documents.allDocuments": "Documents",
  "documents.training": "Training",
  "documents.category.1": "Directives",
  "documents.category.2": "Manuals",
  "documents.category.3": "Questionnaires",
  "documents.category.80": "Technical documents",
  "documents.category.4": "Annexes",
  "documents.category.97": "Virtual feedback 2023",
  "documents.category.96": "Cartographic feedback",
  "documents.category.95": "Feedback",
  "documents.category.93": "In-person feedback",
  "documents.category.94": "Presentations",
  "documents.category.98": "Workshop",
  "documents.category.100": "Final report",
  "documents.selectedType": "Selected type ({id})",
  "documents.noMatches": "No matches for “{search}” in {category} for {year}.",
  "documents.emptyCategory": "No documents are available in {category} for {year}.",
  "documents.resultRange": "{start}–{end} of {count} {unit}",
  "documents.page": "Page {page} of {pages}",
  "documents.checkedAt": "Queried on {date} (Lima).",
  "documents.found": "{count} documents found.",
  "documents.published": "Published on {date}",
  "documents.previewTitle": "Preview of {title}",
  "documents.restrictedMessage": "The document archive requires authorization for this query. Please try again later."
};
